import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const mealListSelector = createSelector(
  (state: RootState) => state.meal.mealList,
  (mealList) => mealList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.meal,
  (item) => item.nextToken !== '',
);

export const isInitMealSelector = createSelector(
  (state: RootState) => state.meal,
  (item) => item.nextToken !== null,
);
